import '../Styles/Home.css'
export function Home(){
    return(
        <div className='homeMainDiv'>
            Home page
        </div>
    )
}